<template>

  <div id="dlnkaap_reponse_porteur_map">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <!-- ========== MAIN ========== -->
    <main id="content" role="main" class="bg-light">

      <!-- Content Section -->
      <div class="container-fluid space-1 py-3 mb-2">
        <hr>
        <div class="row">
          <div class="col-12 col-md-7 col-xl-8">
            <div class="pt-md-2 space-bottom-2 " style="height: 700px">
              <l-map
                  ref="map"
                  :zoom="zoom"
                  :center="center"
                  :options="mapOptions"
                  style="height: 100%"
              >
                <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                />
                <l-marker v-for="aap in aaps" v-if="aap.latitude != null && aap.longitude != null" :lat-lng="[aap.latitude, aap.longitude]" :key="aap.id" :icon="marker_icon">
                  <l-tooltip>{{aap.projet_nom}} ({{aap.nom}})</l-tooltip>
                  <l-popup>
                    <div>
                      {{aap.projet_nom}} ({{aap.nom}})
                      <p class="text-center">
                        <a class="btn btn-primary text-white"
                           :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + aap.id">
                          En savoir plus
                        </a>
                      </p>
                      <p>
                        {{aap.presentation}}
                      </p>
                    </div>
                  </l-popup>
                  <!--                        @click="marker_click(aap.id)">-->
                  <!--                <l-popup> {{ open_popup(aap.id) }}</l-popup>-->
                </l-marker>
              </l-map>
            </div>
          </div>

          <div v-if="show_detail" class="col-12 col-md-5 col-xl-4">
            <h3 class="umap-browse-title">
              <button type="button" class="btn btn-info" @click="back">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;
                Retour
              </button>
            </h3>

            <a class="card" :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + current_aap.id">
              <div class="card-img-top position-relative">

                <img class="w-50" :src="logo_structure"
                     :alt="'Visuel du projet : ' + current_aap.projet_nom">

                <!--              <figure class="ie-curved-y position-absolute right-0 bottom-0 left-0 mb-n1">-->
                <!--                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">-->
                <!--                  <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>-->
                <!--                </svg>-->
                <!--              </figure>-->

                <div class="d-flex flex-wrap position-absolute" style="top: 10px; left: 10px;">
                <span class="badge badge-secondary">
                  <i aria-hidden="true" class="fa fa-eye mr-1"></i>{{current_aap.views}}
                </span>
                </div>
              </div>
              <div class="card-body">
                <h3>
                  <p class="text-inherit">
                    {{current_aap.projet_nom}}
                  </p>
                </h3>
                <p>
                  {{ current_aap.presentation }}
                </p>

                <div class="text-center">
                  <a class="btn btn-primary"
                     :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + current_aap.id">
                    En savoir plus
                  </a>
                </div>

              </div>
              <div class="card-footer py-3 border-top-2">
                <div class="row d-flex align-items-center justify-content-between">
                  <div class="ml-3">
                    <p class="font-weight-bold mb-0">{{ current_aap.nom }}</p>
                  </div>
                  <!--              <div class="px-1">-->
                  <!--                <p class="text-muted mb-0"> 14/04/2022 </p>-->
                  <!--              </div>-->
                </div>
              </div>
            </a>
          </div>
          <div v-else class="col-12 col-md-5 col-xl-4">

            <div class="body" style="height: 700px; overflow: scroll">
              <h3 class="umap-browse-title">Ils oeuvrent sur le territoire</h3>

              <div class="umap-browse-features">
                <table class="table table-sm table-striped table-hover">
                  <tbody>
                  <tr v-for="aap in aaps" :key="aap.id">
                    <td>
                      <i class="fas fa-search-plus" title="Centrer la carte sur cet élément" data-toggle="tooltip"
                         @click="show_aap(aap)"></i>
                    </td>
                    <td>
                      <span class="feature-title">{{ aap.projet_nom }} (<strong>{{ aap.nom }}</strong>)</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
        <hr>
        <!-- End Row -->
      </div>
      <!-- End Content Section -->
    </main>
    <!-- ========== END MAIN ========== -->

  </div>
</template>


<script>

import {LMap, LTileLayer, LMarker, LTooltip, LPopup} from "vue2-leaflet";

export default {

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPopup,
  },

  props: {
    aaps: []
  },
  data: function () {
    return {
      message: "",
      message_type: "",
      wait_data: true,

      show_detail: false,

      marker_icon: L.icon({
        iconUrl: "/themes/template/img/map/marker-icon-blue.png",
        iconSize: [20, 30],
        iconAnchor: [10, 30],
        popupAnchor: [0, -30],
      }),

      zoom: 11,
      initial_zoom: 11,
      center: ["48.91853", "2.11389 "],
      initial_center: ["48.91853", "2.11389 "],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      },

    }
  },
  mounted() {
    this.wait_data = false
  },

  created: function () {
    window.addEventListener('mousedown', this.mouseDownEvent);
  },
  destroyed: function () {
    window.removeEventListener('mousedown', this.mouseDownEvent);
  },


  computed: {},

  watch: {

  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    back: function () {
      this.center = this.initial_center
      this.zoom = this.initial_zoom
      this.show_detail = false
      this.current_aap = null
    },

    show_aap: function (aap) {
      this.center = [aap.latitude, aap.longitude]
      setTimeout(() => {
        this.zoom = 15
      }, 300)
      this.show_detail = true
      this.current_aap = aap
    },


  }
}

</script>

<style scoped>


</style>
